/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AmountDto as OkEgisServiceModelsDtoAmountDto } from '../models/OK/Egis/Service/Models/DTO/amount-dto';
import { CreateServiceaftaleRequestDto as OkEgisServiceModelsDtoCreateServiceaftaleRequestDto } from '../models/OK/Egis/Service/Models/DTO/create-serviceaftale-request-dto';
import { GetPriceServiceaftaleResponseDto as OkEgisServiceModelsDtoGetPriceServiceaftaleResponseDto } from '../models/OK/Egis/Service/Models/DTO/get-price-serviceaftale-response-dto';
import { GetPriceRequest as OkEgisServiceModelsRequestGetPriceRequest } from '../models/OK/Egis/Service/Models/Request/get-price-request';
import { ServiceaftalePricecacheUpdateDto as OkEgisServiceModelsResponseServiceaftalePricecacheUpdateDto } from '../models/OK/Egis/Service/Models/Response/serviceaftale-pricecache-update-dto';

@Injectable({
  providedIn: 'root',
})
export class PriceService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getPriceForServiceAftale
   */
  static readonly GetPriceForServiceAftalePath = '/api/v1/Price/GetPriceForServiceAftale';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPriceForServiceAftale()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPriceForServiceAftale$Response(params: {
    serviceaftaleId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoGetPriceServiceaftaleResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, PriceService.GetPriceForServiceAftalePath, 'get');
    if (params) {
      rb.query('serviceaftaleId', params.serviceaftaleId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoGetPriceServiceaftaleResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPriceForServiceAftale$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPriceForServiceAftale(params: {
    serviceaftaleId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoGetPriceServiceaftaleResponseDto> {

    return this.getPriceForServiceAftale$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoGetPriceServiceaftaleResponseDto>) => r.body as OkEgisServiceModelsDtoGetPriceServiceaftaleResponseDto)
    );
  }

  /**
   * Path part for operation getPriceForEditedServiceAftale
   */
  static readonly GetPriceForEditedServiceAftalePath = '/api/v1/Price/GetPriceForEditedServiceAftale';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPriceForEditedServiceAftale()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPriceForEditedServiceAftale$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestGetPriceRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoGetPriceServiceaftaleResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, PriceService.GetPriceForEditedServiceAftalePath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoGetPriceServiceaftaleResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPriceForEditedServiceAftale$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPriceForEditedServiceAftale(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestGetPriceRequest
  }): Observable<OkEgisServiceModelsDtoGetPriceServiceaftaleResponseDto> {

    return this.getPriceForEditedServiceAftale$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoGetPriceServiceaftaleResponseDto>) => r.body as OkEgisServiceModelsDtoGetPriceServiceaftaleResponseDto)
    );
  }

  /**
   * Path part for operation getPriceServiceaftale
   */
  static readonly GetPriceServiceaftalePath = '/api/v1/Price/GetPriceServiceaftale';

  /**
   * Gets price for Serviceaftale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPriceServiceaftale()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPriceServiceaftale$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoCreateServiceaftaleRequestDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoGetPriceServiceaftaleResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, PriceService.GetPriceServiceaftalePath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoGetPriceServiceaftaleResponseDto>;
      })
    );
  }

  /**
   * Gets price for Serviceaftale.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPriceServiceaftale$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPriceServiceaftale(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoCreateServiceaftaleRequestDto
  }): Observable<OkEgisServiceModelsDtoGetPriceServiceaftaleResponseDto> {

    return this.getPriceServiceaftale$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoGetPriceServiceaftaleResponseDto>) => r.body as OkEgisServiceModelsDtoGetPriceServiceaftaleResponseDto)
    );
  }

  /**
   * Path part for operation getPriceForFrieTilkald
   */
  static readonly GetPriceForFrieTilkaldPath = '/api/v1/Price/GetPriceForFrieTilkald';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPriceForFrieTilkald()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPriceForFrieTilkald$Response(params: {
    ServiceaftaleId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoAmountDto>> {

    const rb = new RequestBuilder(this.rootUrl, PriceService.GetPriceForFrieTilkaldPath, 'get');
    if (params) {
      rb.query('ServiceaftaleId', params.ServiceaftaleId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoAmountDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPriceForFrieTilkald$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPriceForFrieTilkald(params: {
    ServiceaftaleId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoAmountDto> {

    return this.getPriceForFrieTilkald$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoAmountDto>) => r.body as OkEgisServiceModelsDtoAmountDto)
    );
  }

  /**
   * Path part for operation getPeriodPriceForFrieTilkald
   */
  static readonly GetPeriodPriceForFrieTilkaldPath = '/api/v1/Price/GetPeriodPriceForFrieTilkald';

  /**
   * Gets price frie tilkald from interval start and until supplied date.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPeriodPriceForFrieTilkald()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPeriodPriceForFrieTilkald$Response(params: {
    ServiceaftaleId?: number;
    calculationDate?: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoAmountDto>> {

    const rb = new RequestBuilder(this.rootUrl, PriceService.GetPeriodPriceForFrieTilkaldPath, 'get');
    if (params) {
      rb.query('ServiceaftaleId', params.ServiceaftaleId, {});
      rb.query('calculationDate', params.calculationDate, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoAmountDto>;
      })
    );
  }

  /**
   * Gets price frie tilkald from interval start and until supplied date.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPeriodPriceForFrieTilkald$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPeriodPriceForFrieTilkald(params: {
    ServiceaftaleId?: number;
    calculationDate?: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoAmountDto> {

    return this.getPeriodPriceForFrieTilkald$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoAmountDto>) => r.body as OkEgisServiceModelsDtoAmountDto)
    );
  }

  /**
   * Path part for operation recalculatePriceForAllAgreements
   */
  static readonly RecalculatePriceForAllAgreementsPath = '/api/v1/Price/RecalculatePriceForAllAgreements';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `recalculatePriceForAllAgreements()` instead.
   *
   * This method doesn't expect any request body.
   */
  recalculatePriceForAllAgreements$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsResponseServiceaftalePricecacheUpdateDto>> {

    const rb = new RequestBuilder(this.rootUrl, PriceService.RecalculatePriceForAllAgreementsPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsResponseServiceaftalePricecacheUpdateDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `recalculatePriceForAllAgreements$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  recalculatePriceForAllAgreements(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsResponseServiceaftalePricecacheUpdateDto> {

    return this.recalculatePriceForAllAgreements$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsResponseServiceaftalePricecacheUpdateDto>) => r.body as OkEgisServiceModelsResponseServiceaftalePricecacheUpdateDto)
    );
  }

}
